import { NoCodeCourse } from './types';

export const NO_CODE_COURSES: NoCodeCourse[] = [
  {
    id: 'microsoft-power-platform-advanced',
    title: 'Microsoft Power Platform Advanced',
    description: 'Master advanced Power Platform development including Power Apps, Power Automate, Power BI, and Power Virtual Agents for enterprise solutions.',
    level: 'advanced',
    totalDuration: '10 hours',
    image: '/api/placeholder/400/300',
    tags: ['Power Platform', 'Power Apps', 'Power Automate', 'Power BI', 'Microsoft 365', 'Enterprise'],
    prerequisites: ['Basic Power Platform knowledge', 'Microsoft 365 familiarity', 'Business process understanding'],
    estimatedHours: 10,
    objectives: [
      'Build complex enterprise Power Apps',
      'Create advanced Power Automate workflows',
      'Develop custom connectors and APIs',
      'Implement governance and security best practices'
    ],
    learningOutcomes: [
      'Design scalable Power Apps architectures',
      'Build complex automation workflows',
      'Create custom connectors for external systems',
      'Implement advanced Power BI analytics',
      'Configure enterprise security and governance',
      'Optimize performance and user experience'
    ],
    modules: [
      {
        id: 'power-apps-advanced',
        title: 'Advanced Power Apps Development',
        description: 'Build enterprise-grade applications',
        content: 'Learn advanced Power Apps patterns for complex business solutions...',
        duration: '3 hours',
        difficulty: 'advanced',
        order: 1,
        estimatedTime: '3 hours',
        learningObjectives: [
          'Master component libraries and reusability',
          'Implement complex data models',
          'Create responsive, accessible interfaces'
        ],
        codeExamples: [
          {
            title: 'Power Fx Formula Example',
            code: 'UpdateIf(\n  Orders,\n  Status = "Pending" && DateDiff(Today(), OrderDate, Days) > 30,\n  {\n    Status: "Overdue",\n    LastUpdated: Now(),\n    UpdatedBy: User().Email\n  }\n)',
            explanation: 'Power Fx formula to update overdue orders in a collection.',
            language: 'powerfx'
          }
        ]
      },
      {
        id: 'power-automate-enterprise',
        title: 'Enterprise Power Automate Workflows',
        description: 'Build complex automation solutions',
        content: 'Design sophisticated workflows for enterprise processes...',
        duration: '2.5 hours',
        difficulty: 'advanced',
        order: 2
      },
      {
        id: 'custom-connectors',
        title: 'Custom Connectors and APIs',
        description: 'Extend Power Platform with custom integrations',
        content: 'Create custom connectors to integrate with any API...',
        duration: '2 hours',
        difficulty: 'advanced',
        order: 3
      },
      {
        id: 'power-platform-governance',
        title: 'Governance and Security',
        description: 'Implement enterprise governance practices',
        content: 'Establish governance frameworks for Power Platform deployment...',
        duration: '1.5 hours',
        difficulty: 'advanced',
        order: 4
      },
      {
        id: 'power-platform-alm',
        title: 'Application Lifecycle Management',
        description: 'Manage Power Platform solutions professionally',
        content: 'Implement DevOps practices for Power Platform solutions...',
        duration: '1 hour',
        difficulty: 'advanced',
        order: 5
      }
    ],
    type: 'no-code'
  },
  {
    id: 'advanced-automation-zapier-make',
    title: 'Advanced Automation with Zapier & Make',
    description: 'Build sophisticated automation workflows using Zapier and Make (formerly Integromat) for complex business processes.',
    level: 'intermediate',
    totalDuration: '6 hours',
    image: '/api/placeholder/400/300',
    tags: ['Zapier', 'Make', 'Integromat', 'Automation', 'Workflow', 'Integration'],
    prerequisites: ['Basic automation concepts', 'Understanding of APIs', 'Business process knowledge'],
    estimatedHours: 6,
    objectives: [
      'Design complex multi-step automations',
      'Implement error handling and monitoring',
      'Create custom webhooks and API integrations',
      'Optimize automation performance and costs'
    ],
    learningOutcomes: [
      'Build sophisticated Zapier workflows',
      'Create advanced Make scenarios',
      'Implement conditional logic and branching',
      'Handle errors and edge cases gracefully',
      'Monitor and optimize automation performance',
      'Integrate hundreds of applications seamlessly'
    ],
    modules: [
      {
        id: 'zapier-advanced-workflows',
        title: 'Advanced Zapier Workflows',
        description: 'Build complex multi-step automations',
        content: 'Master advanced Zapier features for sophisticated workflows...',
        duration: '2 hours',
        difficulty: 'intermediate',
        order: 1
      },
      {
        id: 'make-scenarios-advanced',
        title: 'Advanced Make Scenarios',
        description: 'Create powerful automation scenarios with Make',
        content: 'Leverage Make\'s visual workflow builder for complex processes...',
        duration: '2 hours',
        difficulty: 'intermediate',
        order: 2
      },
      {
        id: 'automation-error-handling',
        title: 'Error Handling and Monitoring',
        description: 'Build reliable automation systems',
        content: 'Implement robust error handling and monitoring strategies...',
        duration: '1 hour',
        difficulty: 'advanced',
        order: 3
      },
      {
        id: 'custom-webhooks-apis',
        title: 'Custom Webhooks and API Integration',
        description: 'Extend automation capabilities with custom integrations',
        content: 'Create custom webhooks and integrate with any API...',
        duration: '1 hour',
        difficulty: 'advanced',
        order: 4
      }
    ],
    type: 'no-code'
  },
  {
    id: 'enterprise-no-code-architecture',
    title: 'Enterprise No-Code Architecture',
    description: 'Design and implement scalable no-code solutions for enterprise environments with proper governance and security.',
    level: 'expert',
    totalDuration: '8 hours',
    image: '/api/placeholder/400/300',
    tags: ['Enterprise Architecture', 'No-Code', 'Governance', 'Scalability', 'Security', 'Digital Transformation'],
    prerequisites: ['Enterprise architecture experience', 'No-code platform knowledge', 'Business analysis skills'],
    estimatedHours: 8,
    objectives: [
      'Design enterprise no-code architectures',
      'Implement governance frameworks',
      'Ensure security and compliance',
      'Scale no-code solutions across organizations'
    ],
    learningOutcomes: [
      'Design scalable no-code architectures',
      'Establish governance and security frameworks',
      'Implement center of excellence practices',
      'Manage citizen development programs',
      'Ensure compliance with regulations',
      'Optimize costs and resource utilization'
    ],
    modules: [
      {
        id: 'enterprise-nocode-strategy',
        title: 'Enterprise No-Code Strategy',
        description: 'Develop organizational no-code strategies',
        content: 'Create comprehensive strategies for enterprise no-code adoption...',
        duration: '2 hours',
        difficulty: 'expert',
        order: 1
      },
      {
        id: 'nocode-governance-framework',
        title: 'Governance Framework Implementation',
        description: 'Establish governance for no-code platforms',
        content: 'Implement governance frameworks for controlled no-code deployment...',
        duration: '2 hours',
        difficulty: 'expert',
        order: 2
      },
      {
        id: 'citizen-development-program',
        title: 'Citizen Development Programs',
        description: 'Enable and manage citizen developers',
        content: 'Create programs to empower business users with no-code tools...',
        duration: '2 hours',
        difficulty: 'advanced',
        order: 3
      },
      {
        id: 'nocode-security-compliance',
        title: 'Security and Compliance',
        description: 'Ensure enterprise security in no-code solutions',
        content: 'Implement security controls and compliance measures...',
        duration: '1 hour',
        difficulty: 'expert',
        order: 4
      },
      {
        id: 'nocode-center-excellence',
        title: 'Center of Excellence',
        description: 'Establish no-code centers of excellence',
        content: 'Create organizational structures to support no-code initiatives...',
        duration: '1 hour',
        difficulty: 'expert',
        order: 5
      }
    ],
    type: 'no-code'
  }
];